import React from 'react';
import { List } from 'antd';
import NewsCard from './components/NewsCard';
import { newsDataSource as data } from '@/articles/data';

export const Feature50DataSource = {
  wrapper: { className: 'home-page-wrapper news-wrapper' },
  page: { className: 'home-page news' },
  OverPack: {},
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: 'news.newsTrends',
        className: 'title-h1',
      },
      { name: 'content', children: 'NEWS TRENDS' },
    ],
  },
  tabsWrapper: { className: 'news-tabs-wrapper' },
  block: {
    children: [
      {
        name: 'block0',
        tag: {
          className: 'news-tag',
          text: { children: 'news.productDynamics', className: 'news-tag-name' },
          icon: { children: 'mobile' },
        },
        content: {
          className: 'news-content',
          text: {
            className: 'news-text',
            children: (
              <div>
                <List
                  grid={{ gutter: 20, xs: 1, md: 2 }}
                  dataSource={data.product}
                  renderItem={(item) => (
                    <List.Item>
                      <NewsCard
                        {...item}
                      />
                    </List.Item>
                  )}
                />
              </div>
            ),
          },
          img: {
            className: 'news-img',
            children:
              'https://zos.alipayobjects.com/rmsportal/xBrUaDROgtFBRRL.png',
            md: 10,
            xs: 24,
          },
        },
      },
      {
        name: 'block1',
        tag: {
          className: 'news-tag',
          icon: { children: 'tablet' },
          text: { className: 'news-tag-name', children: 'news.companyDynamics' },
        },
        content: {
          className: 'news-content',
          text: {
            className: 'news-text',
            md: 14,
            xs: 24,
            children: (
              <div>
                <List
                  grid={{ gutter: 20, xs: 1, md: 2 }}
                  dataSource={data.company}
                  renderItem={(item) => (
                    <List.Item>
                      <NewsCard
                        {...item}
                      />
                    </List.Item>
                  )}
                />
              </div>
            ),
          },
          img: {
            className: 'news-img',
            md: 10,
            xs: 24,
            children:
              'https://zos.alipayobjects.com/rmsportal/xBrUaDROgtFBRRL.png',
          },
        },
      },
      {
        name: 'block2',
        tag: {
          className: 'news-tag',
          text: { children: 'news.industryDynamics', className: 'news-tag-name' },
          icon: { children: 'laptop' },
        },
        content: {
          className: 'news-content',
          text: {
            className: 'news-text',
            md: 14,
            xs: 24,
            children: (
              <div>
                <List
                  grid={{ gutter: 20, xs: 1, md: 2 }}
                  dataSource={data.profession}
                  renderItem={(item) => (
                    <List.Item>
                      <NewsCard
                        {...item}
                      />
                    </List.Item>
                  )}
                />
              </div>
            ),
          },
          img: {
            className: 'news-img',
            md: 10,
            xs: 24,
            children:
              'https://zos.alipayobjects.com/rmsportal/xBrUaDROgtFBRRL.png',
          },
        },
      },
    ],
  },
};
